import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '@root/firebase'; // Firebase initialization

const LogError = async (eventType, details = {}) => {
  // Ensure details are fully serializable
  const safeDetails = {
    ...details,
    error:
      details.error instanceof Error
        ? {
            message: details.error.message || 'Unknown error',
            stack: details.error.stack || 'No stack trace available',
            name: details.error.name || 'Error',
          }
        : details.error || {}, // If it's not an Error object, keep it as is
  };

  try {
    await addDoc(collection(db, 'user_errors'), {
      eventType,
      details: safeDetails, // Ensure only serializable data is stored
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    console.error('Error logging event: ', error);
  }
};

export default LogError;
